import { SingleLoader } from './components';

export default function Loading() {
  return (
    <article className="mt-6 flex flex-col items-start gap-6">
      <SingleLoader />
    </article>
  );
}
